<script lang="ts">
  import TaskList from "@/components/task/task-list.svelte"
  import AppLayout from "@/layouts/app-layout.svelte"
  import { userDashboardTaskHistoryPath } from "@/routes"
  import type { BreadcrumbItem, TaskInstance } from "@/types"

  interface Props {
    taskInstances: TaskInstance[]
  }

  let { taskInstances }: Props = $props()

  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: "Task History",
      href: userDashboardTaskHistoryPath(),
    },
  ]
</script>

<svelte:head>
  <title>Task History - Chorizo</title>
</svelte:head>

<AppLayout {breadcrumbs}>
  <div class="flex h-full flex-1 flex-col gap-6 overflow-x-auto rounded-xl p-4">
    <div>
      <h1 class="text-3xl font-bold">Task History</h1>
      <p class="text-muted-foreground mt-2">View your completed tasks</p>
    </div>

    <TaskList tasks={taskInstances} title="All Completed Tasks" />
  </div>
</AppLayout>
